module.exports = __webpack_public_path__ + "static/media/spinner1.92630484.gif";